export default "__VITE_ASSET__Be$wL052__"